import { useCallback } from 'react';

export const useObjectValidation = () => {
  const validateKeys = useCallback(
    <T extends object>(obj: T, requiredKeys: string[], exactPropertyAmount?: boolean) => {
      if (!obj) {
        return false;
      }

      const propertyNames = Object.keys(obj);

      if (exactPropertyAmount && requiredKeys.length !== propertyNames.length) return false;

      return requiredKeys.every((key) => propertyNames.includes(key));
    },
    [],
  );

  return { validateKeys };
};
